import fileSys from "../../fileoprators/fileSystem";
import { downloadFile } from "../../services/media";
import { paramNormal } from "../../shared/filters";
import { logStdout } from "../../shared/utils";
import { MAPSTYLES, isDefined } from "../shared";
import GenReportMap from "./GenReportMap";

export class Topography3rd {
  constructor(patient, record, casePath, eyeType) {
    this.patient = patient;
    this.casePath = casePath;
    this.eyeType = eyeType;
    this.record = record;
  }
  normalFourMaps(callback, dir) {
    let genReportMap = new GenReportMap();
    let dstpath = "";
    let maps = {};
    if (
      this.record &&
      this.record.content[`data${this.eyeType}`]["topography"] &&
      this.record.content[`data${this.eyeType}`]["topography"].diagnosed
    ) {
      genReportMap = new GenReportMap(this.casePath, 0xff2d3039);
      let obj = genReportMap.getMap(MAPSTYLES.TCurvatureF, 0, true);
      dstpath = dir
        ? fileSys.combinePath(dir, "tCurvature.png")
        : fileSys.getUtilPath("thirdparty/tCurvature.png");
      fileSys.deleteFile(dstpath);
      fileSys.bmpData2Png(obj.bmpData, obj.size.width, obj.size.height, dstpath, (err) => {
        if (!err) {
          if (this.eyeType === "OS") {
            maps.tCurvatureL = {
              filepath: dstpath,
              filename: "tCurvatureL"
            };
          } else {
            maps.tCurvatureR = {
              filepath: dstpath,
              filename: "tCurvatureR"
            };
          }
        }
        obj = genReportMap.getMap(MAPSTYLES.SCurvatureF, 1, true);
        dstpath = dir
          ? fileSys.combinePath(dir, "sCurvature.png")
          : fileSys.getUtilPath("thirdparty/sCurvature.png");
        fileSys.deleteFile(dstpath);
        fileSys.bmpData2Png(obj.bmpData, obj.size.width, obj.size.height, dstpath, (err) => {
          if (!err) {
            if (this.eyeType === "OS") {
              maps.sCurvatureL = {
                filepath: dstpath,
                filename: "sCurvatureL"
              };
            } else {
              maps.sCurvatureR = {
                filepath: dstpath,
                filename: "sCurvatureR"
              };
            }
          }
          obj = genReportMap.getMap(MAPSTYLES.ElevationF, 2, true);
          dstpath = dir
            ? fileSys.combinePath(dir, "elevation.png")
            : fileSys.getUtilPath("thirdparty/elevation.png");
          fileSys.deleteFile(dstpath);
          fileSys.bmpData2Png(obj.bmpData, obj.size.width, obj.size.height, dstpath, (err) => {
            if (!err) {
              if (this.eyeType === "OS") {
                maps.elevationL = {
                  filepath: fileSys.getUtilPath("thirdparty/elevation.png"),
                  filename: "elevationL"
                };
              } else {
                maps.elevationR = {
                  filepath: fileSys.getUtilPath("thirdparty/elevation.png"),
                  filename: "elevationR"
                };
              }
            }
            obj = genReportMap.getMap(MAPSTYLES.FRP, 3, true);
            dstpath = dir
              ? fileSys.combinePath(dir, "frp.png")
              : fileSys.getUtilPath("thirdparty/frp.png");

            fileSys.deleteFile(dstpath);
            fileSys.bmpData2Png(obj.bmpData, obj.size.width, obj.size.height, dstpath, (err) => {
              if (!err) {
                if (this.eyeType === "OS") {
                  maps.frpL = {
                    filepath: dstpath,
                    filename: "frpL"
                  };
                } else {
                  maps.frpR = {
                    filepath: dstpath,
                    filename: "frpR"
                  };
                }
              }
            });
            if (fileSys.isFileExists(fileSys.combinePath(this.casePath, "original.jpg"))) {
              if (this.eyeType === "OS") {
                maps.originalL = {
                  filepath: fileSys.combinePath(this.casePath, "original.jpg"),
                  filename: "originalL"
                };
              } else {
                maps.originalR = {
                  filepath: fileSys.combinePath(this.casePath, "original.jpg"),
                  filename: "originalR"
                };
              }
            }
            if (callback) callback(maps);
          });
        });
      });
    }
  }
  normalPupilImage(file, callback) {
    downloadFile(file, fileSys.getUtilPath("thirdparty"), "pupilOriginal.jpg", (err) => {
      if (err) {
        callback(err);
      } else {
        if (this.eyeType === "OS") {
          let result = {
            pupilOriginalL: {
              filepath: fileSys.getUtilPath("thirdparty/pupilOriginal.jpg"),
              filename: "pupilOriginalL"
            }
          };
          callback(null, result);
        } else {
          let result = {
            pupilOriginalR: {
              filepath: fileSys.getUtilPath("thirdparty/pupilOriginal.jpg"),
              filename: "pupilOriginalR"
            }
          };
          callback(null, result);
        }
      }
    });
  }
  normalParamsData(params, pupilcornea, callback) {
    let data = {};
    if (params) {
      Object.assign(data, {
        K1: paramNormal(params["K1"].value),
        Rf: paramNormal(params["Rf"].value),
        K2: paramNormal(params["K2"].value),
        Rs: paramNormal(params["Rs"].value),
        Km: paramNormal(params["Km"].value),
        Rm: paramNormal(params["Rm"].value),
        Asig: paramNormal(params["Astig"].value),
        Ecc: paramNormal(params["EccPEQ"].value),
        Kmax: paramNormal(params["Kmax"].value),
        Rmin: paramNormal(params["Rmin"].value),
        axisFlat: paramNormal(params["AxisFlat"].value),
        axisSteep: paramNormal(params["AxisSteep"].value),
        elevDiff: paramNormal(params["elevDiff4mm"].value, { fixed: 0 }),
        fSagHeight4mm: paramNormal(params["fSagHeight4mm"].value),
        fSagHeight8mm: paramNormal(params["fSagHeight8mm"].value),
        flatE6mm: paramNormal(params["flatE6mm"]),
        steepE6mm: paramNormal(params["steepE6mm"]),
        flatE8mm: paramNormal(params["flatE8mm"]),
        steepE8mm: paramNormal(params["steepE8mm"]),
        pupilDiameter:
          pupilcornea && isDefined(pupilcornea.pupilDiameter) ? pupilcornea.pupilDiameter : "--",
        corneaDiameter:
          pupilcornea && isDefined(pupilcornea.corneaDiameter) ? pupilcornea.corneaDiameter : "--"
      });
      this.normalFourMaps((maps) => {
        if (callback) callback(null, data, maps);
      });
    }
    if (pupilcornea) {
      Object.assign(data, {
        pupilDiameter: isDefined(pupilcornea.pupilDiameter) ? pupilcornea.pupilDiameter : "--",
        corneaDiameter: isDefined(pupilcornea.corneaDiameter) ? pupilcornea.corneaDiameter : "--"
      });
      logStdout("pupilcornea file", pupilcornea.file);
      this.normalPupilImage(pupilcornea.file, (err, result) => {
        if (err) callback(err);
        else {
          callback(null, data, result);
        }
      });
    }
    return data;
  }
}
export class DryEye3rd {
  constructor(record, eyeType) {
    this.eyeType = eyeType;
    this.record = record;
    this.batchNo = record._id;
    this.images = {};
  }
  normalDryEyeVideo(file, name, callback) {
    downloadFile(file, fileSys.getUtilPath("thirdparty"), `${name}.mp4`, (err) => {
      if (err) {
        callback(err);
      } else {
        let result = {
          [name]: {
            filepath: fileSys.getUtilPath(`thirdparty/${name}.mp4`),
            filename: name
          }
        };
        callback(null, result);
      }
    });
  }
  normalDryEyeImages(files, fileNames, callback) {
    if (!files || files.length <= 0) {
      callback(null, this.images);
    } else {
      let file = files.pop();
      let filename = fileNames.pop();
      downloadFile(file, fileSys.getUtilPath("thirdparty"), `${filename}.jpg`, (err) => {
        if (err) {
          callback(err);
        } else {
          this.images[filename] = {
            filepath: fileSys.getUtilPath(`thirdparty/${filename}.jpg`),
            filename: filename
          };
          this.normalDryEyeImages(files, fileNames, callback);
        }
      });
    }
  }
  FIRSTRUPTURETIME(nibut) {
    if (nibut["firstrupturetime"]) {
      if (nibut["firstrupturetime"] === -1) {
        return ">0s";
      } else if (nibut["firstrupturetime"] === 10000) {
        return nibut["usefultime"] ? `>${Number(nibut["usefultime"]._toFixed(2))}s` : ">21s";
      } else {
        return `${nibut["firstrupturetime"]._toFixed(2)}s`;
      }
    } else if (nibut["firstrupturetime"] === 0) {
      return `0.04s`;
    } else {
      return "--";
    }
  }
  AVGRUPTRURETIME(nibut) {
    if (nibut["avgruptruretime"]) {
      if (nibut["avgruptruretime"] === -1) {
        return ">0";
      } else if (nibut["avgruptruretime"] === 10000) {
        return nibut["usefultime"] ? `>${Number(nibut["usefultime"]._toFixed(2))}` : ">21";
      } else {
        return `${nibut["avgruptruretime"]._toFixed(2)}`;
      }
    } else {
      return "--";
    }
  }
  handleValue(val) {
    if (val === undefined || val === "") {
      return "--";
    } else if (val === -1 || val === -1000) {
      return "--";
    } else {
      return (Math.floor(val * 1000) / 10).toString();
    }
  }
  AUTOCALCVALUE(tearheight) {
    let deal;
    deal = tearheight.trensdDataYHeigth
      ? tearheight.trensdDataYHeigth * window.magecoe.tearheight
      : tearheight.clonetrensdDataYHeigth * window.magecoe.tearheight;
    if (!isDefined(deal) || deal < 0) return "--";
    else deal = deal._toFixed(2);
    if (tearheight.trensdDataYHeigth === "--") {
      deal = "--";
    }
    return deal.toString();
  }
  meibomianLevelCal(loss) {
    loss = loss === 0 ? 0 : loss > 0 && loss <= 33 ? 1 : loss > 33 && loss <= 66 ? 2 : 3;
    return loss.toString();
  }

  normalDryEyeData(record, mode, text, callback) {
    let data = {};
    let nibut = record.content[`data${this.eyeType}`]["nibut"];
    let tearheight = record.content[`data${this.eyeType}`]["tearheight"];
    let lipidlayer = record.content[`data${this.eyeType}`]["lipidlayer"];
    let meibomian = record.content[`data${this.eyeType}`]["meibomian"];
    let eyelidedge = record.content[`data${this.eyeType}`]["eyelidedge"];
    let eyeredness = record.content[`data${this.eyeType}`]["eyeredness"];
    let ocularsurface = record.content[`data${this.eyeType}`]["ocularsurface"];

    Object.assign(data, {
      measureType: "dryeye",
      measureDate: record.testtime,
      eyetype: this.eyeType,
      firstRuptureTime: isDefined(nibut) ? this.FIRSTRUPTURETIME(nibut) : "0",
      avgRuptrureTime: isDefined(nibut) ? this.AVGRUPTRURETIME(nibut) : "0",
      trensDataYHeigth: isDefined(tearheight) ? this.AUTOCALCVALUE(tearheight) : "0",
      manualMeasureAvg: isDefined(tearheight)
        ? isDefined(tearheight["manualMeasureAvg"])
          ? (Math.round(tearheight.manualMeasureAvg * 100) / 100).toString()
          : tearheight.trensdDataYHeigth
            ? (tearheight.trensdDataYHeigth * window.magecoe.tearheight)._toFixed(2).toString()
            : (tearheight.clonetrensdDataYHeigth * window.magecoe.tearheight)._toFixed(2).toString()
        : "0",
      tearHeightArea: isDefined(tearheight)
        ? tearheight.autocalcarea === -1
          ? "--"
          : (tearheight.autocalcarea * Math.pow(window.magecoe.tearheight, 2))
              ._toFixed(2)
              .toString()
        : "0",
      lipidLayerLevel: isDefined(lipidlayer)
        ? isDefined(lipidlayer.level)
          ? lipidlayer.level.toString()
          : "4"
        : "4",
      upGlandLoss: isDefined(meibomian)
        ? isDefined(meibomian["up"])
          ? meibomian["up"]["glandloss"] === 0
            ? "0"
            : (Math.floor(meibomian["up"]["glandloss"] * 1000) / 10).toString()
          : "0"
        : "0",
      upGlandPercent: isDefined(meibomian)
        ? isDefined(meibomian["up"])
          ? meibomian["up"]["glandpercent"] === 0
            ? 0
            : (Math.floor(meibomian["up"]["glandpercent"] * 1000) / 10).toString()
          : "0"
        : "0",
      upMeibomianLevel: isDefined(meibomian)
        ? isDefined(meibomian["up"])
          ? isDefined(meibomian["up"].level)
            ? meibomian["up"].level.toString()
            : this.meibomianLevelCal(Math.floor(meibomian["up"]["glandloss"] * 1000) / 10)
          : "0"
        : "0",
      downMeibomianGlandloss: isDefined(meibomian)
        ? isDefined(meibomian["down"])
          ? meibomian["down"]["glandloss"] === 0
            ? "0"
            : (Math.floor(meibomian["down"]["glandloss"] * 1000) / 10).toString()
          : "0"
        : "0",
      downMeibomianGlandpercent: isDefined(meibomian)
        ? isDefined(meibomian["down"])
          ? meibomian["down"]["glandpercent"] === 0
            ? 0
            : (Math.floor(meibomian["down"]["glandpercent"] * 1000) / 10).toString()
          : "0"
        : "0",
      downMeibomianLevel: isDefined(meibomian)
        ? isDefined(meibomian["down"])
          ? isDefined(meibomian["down"].level)
            ? meibomian["down"].level.toString()
            : this.meibomianLevelCal(Math.floor(meibomian["down"]["glandloss"] * 1000) / 10)
          : "0"
        : "0",
      upEyelidEdgeLevel: isDefined(eyelidedge)
        ? isDefined(eyelidedge["up"])
          ? isDefined(eyelidedge["up"].level)
            ? eyelidedge["up"].level.toString()
            : "0"
          : "0"
        : "0",
      downEyelidEdgeLevel: isDefined(eyelidedge)
        ? isDefined(eyelidedge["down"])
          ? isDefined(eyelidedge["down"].level)
            ? eyelidedge["down"].level.toString()
            : "0"
          : "0"
        : "0",
      cillaryN: isDefined(eyeredness) ? this.handleValue(eyeredness.nasalciliary) : "0",
      cillaryT: isDefined(eyeredness) ? this.handleValue(eyeredness.tempciliary) : "0",
      conjunctivalN: isDefined(eyeredness) ? this.handleValue(eyeredness.nasalconjunctival) : "0",
      conjunctivalT: isDefined(eyeredness) ? this.handleValue(eyeredness.tempconjunctival) : "0"
    });

    if (!text) {
      switch (mode) {
        case "nibut":
          this.normalDryEyeVideo(nibut["photos"][0], "nibutVideo", (err, result) => {
            if (err) callback(err);
            else {
              callback(null, data, result);
            }
          });
          break;
        case "lipidlayer":
          this.normalDryEyeVideo(lipidlayer["photos"][0], "lipidLayerVideo", (err, result) => {
            if (err) callback(err);
            else {
              callback(null, data, result);
            }
          });
          break;
        case "tearheight":
          this.images = {};
          let files = [];
          let fileNames = [];
          if (tearheight["photos"].length > 1) {
            files = [tearheight["photos"][1], tearheight["photos"][2]];
            fileNames = ["tearHeightAreaImage", "tearHeightImage"];
          } else {
            files = [tearheight["photos"][0]];
            fileNames = ["tearHeightImage"];
          }
          this.normalDryEyeImages(files, fileNames, (err, result) => {
            if (err) callback(err);
            else {
              callback(null, data, result);
            }
          });
          break;
        case "meibomian":
          this.images = {};
          if (isDefined(meibomian["up"]) && isDefined(meibomian["down"])) {
            let upFiles = [
              meibomian["up"]["photos"][3],
              meibomian["up"]["photos"][4],
              meibomian["up"]["photos"][5],
              meibomian["down"]["photos"][3],
              meibomian["down"]["photos"][4],
              meibomian["down"]["photos"][5]
            ];
            let upFileNames = [
              "upMeibomianContourImage",
              "upMeibomianEnhanceImage",
              "upMeibomianOriginalImage",
              "downMeibomianContourImage",
              "downMeibomianEnhanceImage",
              "downMeibomianOriginalImage"
            ];
            this.normalDryEyeImages(upFiles, upFileNames, (err, result) => {
              if (err) callback(err);
              callback(null, data, result);
            });
          } else if (isDefined(meibomian["up"])) {
            let upFiles = [
              meibomian["up"]["photos"][3],
              meibomian["up"]["photos"][4],
              meibomian["up"]["photos"][5]
            ];
            let upFileNames = [
              "upMeibomianContourImage",
              "upMeibomianEnhanceImage",
              "upMeibomianOriginalImage"
            ];
            this.normalDryEyeImages(upFiles, upFileNames, (err, result) => {
              if (err) callback(err);
              callback(null, data, result);
            });
          } else if (isDefined(meibomian["down"])) {
            let downFiles = [
              meibomian["down"]["photos"][3],
              meibomian["down"]["photos"][4],
              meibomian["down"]["photos"][5]
            ];
            let downFileNames = [
              "downMeibomianContourImage",
              "downMeibomianEnhanceImage",
              "downMeibomianOriginalImage"
            ];
            this.normalDryEyeImages(downFiles, downFileNames, (err, result) => {
              if (err) callback(err);
              callback(null, data, result);
            });
          }
          // callback(null, data, this.images)
          break;
        case "eyelidedge":
          this.images = {};
          if (isDefined(eyelidedge["up"]) && isDefined(eyelidedge["down"])) {
            this.normalDryEyeImages(
              [eyelidedge["up"]["photos"][1], eyelidedge["down"]["photos"][1]],
              ["upEyelidEdgeImage", "downEyelidEdgeImage"],
              (err, result) => {
                if (err) callback(err);
                callback(null, data, result);
              }
            );
          } else if (isDefined(eyelidedge["up"])) {
            this.normalDryEyeImages(
              [eyelidedge["up"]["photos"][1]],
              ["upEyelidEdgeImage"],
              (err, result) => {
                if (err) callback(err);
                callback(null, data, result);
              }
            );
          } else if (isDefined(eyelidedge["down"])) {
            this.normalDryEyeImages(
              [eyelidedge["down"]["photos"][1]],
              ["downEyelidEdgeImage"],
              (err, result) => {
                if (err) callback(err);
                callback(null, data, result);
              }
            );
          }
          break;
        case "eyeredness":
          this.images = {};
          let eyeRednessFiles = [
            eyeredness["photos"][1],
            eyeredness["photos"][2],
            eyeredness["photos"][3],
            eyeredness["photos"][4]
          ];
          let eyeRednessFileNames = [
            "eyeRednessMaskpartImage",
            "eyeRednessMaskallImage",
            "eyeRednessEnhanceImage",
            "eyeRednessImage"
          ];
          this.normalDryEyeImages(eyeRednessFiles, eyeRednessFileNames, (err, result) => {
            if (err) callback(err);
            else {
              callback(null, data, result);
            }
          });
          break;
        case "ocularsurface":
          this.images = {};
          this.normalDryEyeImages(
            [ocularsurface["photos"][0]],
            ["ocularSurfaceImage"],
            (err, result) => {
              if (err) callback(err);
              else {
                callback(null, data, result);
              }
            }
          );
          break;
        default:
          break;
      }
    } else callback(null, data, null);
  }
}



// WEBPACK FOOTER //
// ./src/topography/js/thirdparty.js